import { render, staticRenderFns } from "./FormRegister.vue?vue&type=template&id=13a7a507"
import script from "./FormRegister.vue?vue&type=script&lang=js"
export * from "./FormRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports